<template>
  <div class="exam-wrap">
    <pageTitle :pageTitle="$t('lang.k_312001')"></pageTitle>
    <div>
      <PushCards scene="material" />
    </div>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  import PushCards from '../../PlatformModule/PushCard/list.vue';
  export default {
    name: 'PushCardMgr',
    components: {
      PageTitle,
      PushCards
    }
  };
</script>
<style lang="less" scoped></style>
